import React, { FC, useContext } from "react";

import {
  Context,
  CREATE_CAREER_CHALLENGE_TOPICS_FAILURE_MESSAGE,
} from "../../../../store/student";
import { Topic } from "../../../../state";
import QuestionHeader from "../QuestionHeader";
import styles from "../ChallengeSheetsModal.module.scss";

type Props = {
  calling: boolean;
  topics: Topic[];
  isCreateTopicsFailed: boolean;
  selectedTopicIds: number[];
  setSelectedTopicIds: (ids: number[]) => void;
  createCareerChallengeTopics: (id: number) => void;
};

const SheetTopics: FC<Props> = ({
  calling,
  topics,
  isCreateTopicsFailed,
  selectedTopicIds,
  setSelectedTopicIds,
  createCareerChallengeTopics,
}) => {
  const { contextState } = useContext(Context);
  const challengeSheet = contextState.career_challenge_sheet;
  const hasTopics = topics.length > 0;
  const isShowLoading = calling && !hasTopics;
  const isShowTopics = hasTopics;
  const isShowError = isCreateTopicsFailed && !calling && !hasTopics;

  const updateSelectedTopicIds = (id: number, checked: boolean) => {
    const topicIds = checked
      ? [...selectedTopicIds, id]
      : selectedTopicIds.filter(topicId => topicId !== id);

    setSelectedTopicIds(topicIds);
  };

  return (
    <div className={styles.content}>
      <p className={styles.intro}>
        進路決定チャレンジシートは、
        <br />
        あなたの進路について整理するためのシートです。
        <br />
        今の考えをまとめて、先生に提出しましょう。
      </p>
      <QuestionHeader
        title={"Q1.あなたが興味を持っていそうなトピック（複数選択可）"}
        note={
          "進路を考える上で、特に気になるキーワードにチェックを入れてみましょう。\n※これまでの回答をもとに、AIがあなた向けのトピックを表示しています。"
        }
      />
      {isShowLoading && (
        <div className={styles.loading}>
          <div className={styles.spinner} />
          <p className={styles.loadingText}>トピック生成中...</p>
        </div>
      )}
      {isShowTopics && (
        <div className={styles.from}>
          <div className={styles.topicList}>
            {topics.map(topic => (
              <div key={topic.id} className={styles.topicItem}>
                <label className={styles.topic}>
                  <input
                    type="checkbox"
                    checked={selectedTopicIds.includes(topic.id)}
                    onChange={e =>
                      updateSelectedTopicIds(topic.id, e.target.checked)
                    }
                  />
                  {topic.content}
                </label>
              </div>
            ))}
          </div>
        </div>
      )}
      {isShowError && (
        <div className={styles.errorMessage}>
          <p className={styles.message}>
            {CREATE_CAREER_CHALLENGE_TOPICS_FAILURE_MESSAGE}。<br />
            通信状況を確認のうえ、もう一度お試しください。
          </p>
          <button
            className={styles.retryButton}
            onClick={() => createCareerChallengeTopics(challengeSheet?.id ?? 0)}
          >
            再試行
          </button>
        </div>
      )}
    </div>
  );
};

export default SheetTopics;
